//@ts-check
import validateField from './fieldValidator';
import helper from './helper';
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @param {any} dispatch
 * @return {Promise<string>}
 */

var validateForm = function validateForm(state, dispatch) {
  var validatePromise = new Promise(function (resolve) {
    var formError = '';
    var firstInvalidPage, firstInvalidField;
    state.layout.pages.forEach(function (pageLayoutId) {
      var pageError = '';
      var pageLayout = state.layout.containers[pageLayoutId];
      var pageFields = helper.findVisibleFields(pageLayout, state);
      pageFields.forEach(function (fieldId) {
        var error = validateField(fieldId, state);
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            fieldId: fieldId,
            error: error
          }
        }); // save first invalid field

        if (error && !firstInvalidField) firstInvalidField = fieldId;
        if (error && !firstInvalidPage) firstInvalidPage = pageLayoutId;
        pageError = pageError || error;
      });
      dispatch({
        type: 'SET_FIELD_ERROR',
        payload: {
          fieldId: pageLayoutId,
          error: pageError
        }
      });

      if (firstInvalidField && firstInvalidPage) {
        dispatch({
          type: 'SET_ACTIVE_PAGE',
          payload: firstInvalidPage
        });
        dispatch({
          type: 'SET_ACTIVE_FIELD',
          payload: firstInvalidField
        });
      }

      formError = formError || pageError;
    });
    resolve(formError);
  });
  return validatePromise;
};

export default validateForm;